module.exports = __webpack_public_path__ + "static/video-1ad33b811c21ba849ebf52139bef5b7a.mp4";